import React from 'react'

import * as styles from './loading.module.scss'

interface Props {
  className?: string
}

export const Loading: React.FC<Props> = ({ className }) => (
  <div
    className={[styles.loading, className].filter((cls) => !!cls).join(' ')}
  />
)
